"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogMatcherForAmounts = exports.createLogMatcherForActions = void 0;
var log_finder_1 = require("@terra-money/log-finder");
var createLogMatcherForActions = function (injectedLogFindersRuleSet) {
    if (injectedLogFindersRuleSet === void 0) { injectedLogFindersRuleSet = []; }
    var logFindersRuleSet = __spreadArray([], injectedLogFindersRuleSet);
    var logFinders = logFindersRuleSet.map(function (_a) {
        var rule = _a.rule, transform = _a.transform;
        return log_finder_1.createReturningLogFinder(rule, transform);
    });
    return function (events) {
        return events === null || events === void 0 ? void 0 : events.flatMap(function (event) {
            return logFinders === null || logFinders === void 0 ? void 0 : logFinders.map(function (logFinderFn) { return logFinderFn(event); });
        });
    };
};
exports.createLogMatcherForActions = createLogMatcherForActions;
var createLogMatcherForAmounts = function (injectedLogFindersRuleSet) {
    if (injectedLogFindersRuleSet === void 0) { injectedLogFindersRuleSet = []; }
    var logFindersRuleSet = __spreadArray([], injectedLogFindersRuleSet);
    var logFinders = logFindersRuleSet.map(function (_a) {
        var rule = _a.rule, transform = _a.transform;
        return log_finder_1.createReturningLogFinder(rule, transform);
    });
    return function (events) {
        return events === null || events === void 0 ? void 0 : events.flatMap(function (event) {
            return logFinders === null || logFinders === void 0 ? void 0 : logFinders.map(function (logFinderFn) { return logFinderFn(event); });
        });
    };
};
exports.createLogMatcherForAmounts = createLogMatcherForAmounts;
//# sourceMappingURL=execute.js.map